var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',{staticStyle:{"background-color":"#f0f2f5"},attrs:{"id":"app"}},[_c('notifications',{attrs:{"group":"foo","position":"bottom right"}}),_c('div',{staticClass:"app-holder"},[_c('router-view',{key:_vm.$route.fullPath})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }